module.exports = __webpack_public_path__ + "static/media/x_promo.478ad2bb.svg";